import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import "../index.css";
import { Link, useNavigate,useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function ThankYouWritingQuiz() {
    const [activePage, setActivePage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
    const { Translate } = useContext(ProductContext);
    const ThankYouQuiz = location.state;
    const categoryId = ThankYouQuiz?.categoryId;
    const dayId = ThankYouQuiz?.dayId;
    const is_review = ThankYouQuiz?.is_review;
    const examId = ThankYouQuiz?.examId;
    const quizTypeId = ThankYouQuiz?.quizTypeId;
    const quizName = ThankYouQuiz?.quizName;
                                         
    // const examTypes = ThankYouQuiz?.examTypes;
    const selectedExamId = ThankYouQuiz?.selectedExamId;
    const backRoute = location.state?.from || "/learning-journey";

        const { LearningId, categoryName, total_time_spent,methodType, examTypes } = location.state || {};



    console.log(examTypes, "examTypes ThankYouQuiz")
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);

    const handleNext = async () => {
        try {
            const token = localStorage.getItem("AuthToken");
            const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
            const examIdVal = examId || selectedExamId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
            const resolvedUniqueDayId = dayId || categoryId;
            const screenTitleId = quizTypeId || localStorage.getItem("screenTitleId") || localStorage.getItem("LearningJourneyActiveScreenId");
            if (token && categoryId && LearningId && screenTitleId && examIdVal && resolvedUniqueDayId) {
                await fetch(`${baseUrl}/api/user-visits/finish-visit`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: resolvedUniqueDayId,
                        unique_day_id: resolvedUniqueDayId,
                        learning_method_id: LearningId,
                        screen_title_id: screenTitleId,
                        examId: examIdVal,
                    }),
                });
            }
        } catch (error) {
            console.error("Error calling finish-visit in ThankYouWritingQuiz:", error);
        }

        const examIdVal = examId || selectedExamId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId");
        navigate("/new-learning-journey", {
            state: {
                selectedExamId: examIdVal,
                examId: examIdVal,
                examTypes: examTypes || [],
            },
        });
    };

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate('/new-learning-journey', { state: { selectedExamId: examId || selectedExamId || localStorage.getItem("selectedExamId") || localStorage.getItem("examId"), examTypes: examTypes || [] } })} className='icon_1' />
                            <h2></h2>  {/* Display the selected day */}
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="thank-you-quiz-container">
                <div className="thank-you-content">
                    <h3>やったー！</h3>

                    <h2>{Translate?.message?.data?.youveCompletedTheQuiz || "You've Completed the Quiz!"}</h2>

                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/finishquiz.png`}
                        className="thank-you-quiz-img"
                    />

                    <div className="thank-you-quiz-button-group">
                        <button
                            className="thank-you-quiz-button"
                            onClick={handleNext}
                        >
                            {Translate?.message?.data?.next || "Next"}
                        </button>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default ThankYouWritingQuiz
